import DrawerNavigator from './DrawerNavigator';
export default DrawerNavigator;
